import { useResources } from "../../hooks/useResources";
import FilterDropdowns from "../filterDropdowns/FilterDropdowns";
import "./PageHeader.scss";

interface PageHeaderProps {
  onRefresh?: () => void;
}

const PageHeader: React.FC<PageHeaderProps> = ({ onRefresh }) => {
  const { getResourceValue } = useResources();

  const handleRefresh = () => {
    if (onRefresh) {
      onRefresh();
    }
  };

  return (
    <header className="header">
      <div className="header__content">
        <div className="logo">
          <a href="/">
            <h1>

              {/* read from resources */}
              {getResourceValue("app_name","Nagwa QMS")}
            </h1>
          </a>
        </div>
        <div className="header__actions">
          <FilterDropdowns className="form-list" />
          <ul className="action-buttons">
            <li>
              <button className="btn refresh-btn" onClick={handleRefresh}>
                <i className="f-icon redo-alt-icon fa-light"></i>
              </button>
            </li>
      
          </ul>
        </div>
      </div>
    </header>
  );
};

export default PageHeader;
